<p-toast position="bottom-center"></p-toast>

<ng-template #objEditor>
  <app-event-request-config-editor
    [existingDisplayNames]="existingDisplayNames"
    [formControl]="configControl"
  ></app-event-request-config-editor>
</ng-template>

<app-settings
  [auditEntry]="auditEntry"
  [doUpload]="upload"
  [editorTemplate]="objEditor"
  [isValid]="isValid"
  [resetForm]="resetForm"
>
</app-settings>
